<template>
  <div class="profile-selector">
    <div class="profile-selector-link">
      <h1 class="headline">{{ $t(`${$route.path}.title`) }}</h1>
      <ul class="profiles">
        <Loader class="loading" v-if="isLoading" />
        <li class="profile" v-for="user in users" :key="user.name">
          <button @click="handleChoiceProfile(user.profile_number)" class="profile-link">
            <img class="profile-image" :alt="user.name" :src="user.avatar" />
            <span class="profile-name">{{ user.name }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { actionTypes } from '@/store/modules/profile/profiles';
import { setItem, getItem } from '@/helpers/storage';
import Loader from '@/components/Loader/Loader.vue';

const store = useStore();
const router = useRouter();

const currentProfile = ref(null);

const users = computed(() => store.state.profiles.data);
const isLoading = computed(() => store.state.profiles.isLoading);

const handleChoiceProfile = (profileNumber) => {
  currentProfile.value = users.value.find((user) => user.profile_number === profileNumber);
  setItem('currentProfile', currentProfile.value);
  router.push(getItem('savedPath') || '/movies');
};

onMounted(() => {
  store.dispatch(actionTypes.getProfiles);
});
</script>

<style lang="scss" scoped>
@import 'style';
</style>
